export default __webpack_public_path__ + "static/media/image2.65ea21c5.webp";